import styles from './NavBar.module.scss';
import { Reducers } from 'store/types';
import { UserProfile } from 'api/account/models/UserProfile';
import { ApplicationPaths, LOGGER_LOG_TYPE, ApplicationName } from 'Config';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LanguagesService from 'api/languages/LanguagesService';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import AccountService from 'api/account/AccountService';
import { setProfile } from 'store/authentication/action';
import Logger from 'common/services/Logger';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FaRegUser, FaGlobe } from 'react-icons/fa';
import { TbLogout } from 'react-icons/tb';
import { Dropdown } from 'react-bootstrap';

export const NAVBAR_BREADCRUMBS_ID = 'navbarBreadcrumbsId';

export const NavBar = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const loggedUser = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const [langs, setLangs] = useState<SelectValueLabel[]>([]);
    const [lang, setLang] = useState<SelectValueLabel | null>(null);

    const changeLang = (selected: SelectValueLabel) => {
        setLang(selected);
        if (selected.label) {
            i18n.changeLanguage(selected.label);
        }
        AccountService.changeLang(selected)
            .finally(() => { getProfile().catch(console.error); });
    }

    useEffect(() => {
        LanguagesService.GetAllForSelectItem()
            .then((data) => {
                setLangs(data);
                setLang(data.find(l => l.value === loggedUser?.languageId) ?? null);
            })
            .catch(() => Logger.error(LOGGER_LOG_TYPE.REQUEST, 'Couldn\'t get languages'));
    }, [loggedUser?.languageId]);

    const getProfile = async () => {
        try {
            const profile = await AccountService.profile();
            dispatch(setProfile(profile) as any);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.REQUEST, 'Couldn\'t get user profile', error);
        }
    }

    return (
        <div className={styles.container}>
            <div className='wrapped-container'>
                <div className={styles.appName}>
                    {ApplicationName}
                </div>
                <div className={styles.bottom}>
                    <div className={styles.breadcrumbs} id={NAVBAR_BREADCRUMBS_ID}></div>
                    <div className={styles.userLinks}>
                        {lang && (
                            <Dropdown align="end" className={styles.langDropdown}>
                                <Dropdown.Toggle as="a" href="#" className={styles.langToggle}>
                                    <FaGlobe /> <span>{lang.fullLabel}</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu variant="dark">
                                    {langs.map(l => (
                                        <Dropdown.Item
                                            key={l.value}
                                            active={l.value === lang.value}
                                            onClick={() => changeLang(l)}
                                        >
                                            {l.fullLabel}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                        <a href="#"><FaRegUser /> <span>{loggedUser?.realName}</span></a>
                        <Link to={ApplicationPaths.LogOut}><TbLogout fontSize={22} /></Link>
                    </div>
                </div>
            </div>
        </div>
    );

    // return (
    //     <Navbar className={`main-header ${styles.navBar}`} data-bs-theme="dark">
    //         <Container fluid className="justify-content-end">
    //             <Navbar.Collapse style={{ flexGrow: 'unset', padding: '0 10px' }}>
    //                 <Nav>
    //                     <NavDropdown title={loggedUser?.realName} menuVariant="dark">
    //                         <NavDropdown.Item onClick={() => navigate('/account/details')}>{t('common.profile')}</NavDropdown.Item>
    //                         <NavDropdown.Item onClick={() => navigate(`${ApplicationPaths.LogOut}`)}>{t('common.logout')}</NavDropdown.Item>
    //                     </NavDropdown>
    //                 </Nav>
    //             </Navbar.Collapse>
    //             {lang && <Navbar.Collapse style={{ flexGrow: 'unset', padding: '0 10px' }}>
    //                 <Nav>
    //                     <NavDropdown title={lang?.fullLabel} menuVariant="dark">
    //                         {langs.map(l => {
    //                             return <NavDropdown.Item onClick={() => changeLang(l)} key={l.value}>{l.fullLabel}</NavDropdown.Item>
    //                         })}
    //                     </NavDropdown>
    //                 </Nav>
    //             </Navbar.Collapse>
    //             }
    //             <Navbar.Brand></Navbar.Brand>
    //         </Container>
    //     </Navbar>
    // );
};
